(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("yup"));
	else if(typeof define === 'function' && define.amd)
		define("json-2-yup", ["yup"], factory);
	else if(typeof exports === 'object')
		exports["json-2-yup"] = factory(require("yup"));
	else
		root["json-2-yup"] = factory(root["yup"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 